﻿(function () {
  'use strict';
  var prods = [];
  var searchTimers = {};
  var WSP = '51960272770';
  var lastTotals = { sub: 0, igv: 0, envMonto: 0, envLabel: 'GRATIS', total: 0, envTipo: 'gratis' };

  /* -- HELPERS -- */
  function g(id) { return document.getElementById(id); }
  function isoDate(d) { return d.toISOString().split('T')[0]; }
  function fmtDate(s) {
    if (!s) return '--';
    var p = s.split('-');
    return p[2] + '/' + p[1] + '/' + p[0];
  }
  function fmtMoney(n) {
    return 'S/ ' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function setText(id, v) { var el = g(id); if (el) el.textContent = v; }

  /* -- INIT -- */
  function init() {
    var n = parseInt(localStorage.getItem('sfymCotN') || '0', 10);
    if (n === 0) { n = 1; localStorage.setItem('sfymCotN', n); }
    g('ccNum').value = 'COT-' + String(n).padStart(4, '0');
    var today = new Date();
    var exp = new Date(); exp.setDate(exp.getDate() + 7);
    g('ccFecha').value = isoDate(today);
    g('ccValidez').value = isoDate(exp);
    renderProdEditor();
    up();
  }

  /* -- CART -- */
  function fromCart() {
    var btn = g('ccCartBtn');
    if (btn) btn.textContent = 'Cargando...';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (btn) btn.innerHTML = '&#x1F6D2; Cargar desde mi carrito';
        if (!cart.items || !cart.items.length) {
          alert('Tu carrito esta vacio.\n\nPrimero ve al catalogo, agrega los productos y regresa aqui.');
          return;
        }
        prods = cart.items.map(function (item) {
          var title = item.product_title || item.title;
          if (item.variant_title && item.variant_title !== 'Default Title') title += ' - ' + item.variant_title;
          return { id: Date.now() + Math.floor(Math.random() * 99999), desc: title, detail: item.sku || '', price: (item.price / 100).toFixed(2), qty: item.quantity };
        });
        renderProdEditor();
        up();
      })
      .catch(function () {
        if (btn) btn.innerHTML = '&#x1F6D2; Cargar desde mi carrito';
        alert('No se pudo leer el carrito. Intenta recargar la pagina.');
      });
  }

  /* -- FECHA CHANGE -- */
  function fechaChange() {
    var f = g('ccFecha').value;
    if (f) {
      var exp = new Date(f + 'T12:00:00');
      exp.setDate(exp.getDate() + 7);
      g('ccValidez').value = isoDate(exp);
    }
    up();
  }

  /* -- PRODUCTS -- */
  function addProd() {
    prods.push({ id: Date.now(), desc: '', detail: '', price: '', qty: 1 });
    renderProdEditor();
  }
  function removeProd(id) {
    prods = prods.filter(function (p) { return p.id !== id; });
    renderProdEditor();
    up();
  }
  function updProd(id, field, val) {
    var p = prods.find(function (x) { return x.id === id; });
    if (!p) return;
    p[field] = (field === 'qty') ? Math.max(1, parseInt(val) || 1) : val;
    up();
  }

  /* -- AUTOCOMPLETE SEARCH -- */
  function searchProd(id, query) {
    var dropEl = g('sfym-drop-' + id);
    if (!dropEl) return;
    if (!query || query.length < 2) {
      dropEl.style.display = 'none';
      return;
    }
    clearTimeout(searchTimers[id]);
    searchTimers[id] = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var results = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!results.length) {
            dropEl.style.display = 'none';
            return;
          }
          dropEl.innerHTML = '';
          results.forEach(function (prod) {
            var rawPrice = parseFloat(String(prod.price || '0').replace(/[^0-9.]/g, '')) || 0;
            var item = document.createElement('div');
            item.className = 'sfym-search-item';
            item.style.cssText = 'padding:7px 12px;cursor:pointer;font-size:12px;border-bottom:1px solid #f0f0f0;display:flex;align-items:center;gap:8px;transition:background .12s;';
            item.onmouseover = function () { this.style.background = '#f0f7f2'; };
            item.onmouseout  = function () { this.style.background = ''; };
            var priceColor = rawPrice === 0 ? '#e67e22' : '#1c4b27';
            var priceText  = rawPrice === 0 ? 'Consultar stock' : (prod.price || 'S/ 0.00');
            var imgUrl = (prod.featured_image && prod.featured_image.url)
              ? prod.featured_image.url.replace(/(\.[a-z]+)(\?|$)/, '_50x50$1$2')
              : '';
            var imgHtml = imgUrl
              ? '<img src="' + imgUrl + '" style="width:34px;height:34px;object-fit:contain;border-radius:4px;flex-shrink:0;border:1px solid #e8e8e8;" alt="">'
              : '<div style="width:34px;height:34px;flex-shrink:0;background:#f5f5f5;border-radius:4px;border:1px solid #e8e8e8;"></div>';
            item.innerHTML =
              imgHtml +
              '<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + esc(prod.title) + '</span>' +
              '<strong style="white-space:nowrap;flex-shrink:0;color:' + priceColor + ';font-size:11px;">' + priceText + '</strong>';
            (function(handle) {
              item.addEventListener('mousedown', function (e) {
                e.preventDefault();
                selectProd(id, prod.title, rawPrice, handle);
              });
            })(prod.handle || (prod.url || '').replace('/products/', '').split('?')[0]);
            dropEl.appendChild(item);
          });
          dropEl.style.display = 'block';
        })
        .catch(function () {
          dropEl.style.display = 'none';
        });
    }, 280);
  }

  function selectProd(id, title, rawPrice, handle) {
    var dropEl = g('sfym-drop-' + id);
    if (dropEl) dropEl.style.display = 'none';
    var p = prods.find(function (x) { return x.id === id; });
    if (!p) return;
    p.desc  = title;
    p.price = rawPrice.toFixed(2);
    var ni = g('sfym-name-' + id);
    if (ni) ni.value = title;
    var pi = g('sfym-price-' + id);
    if (pi) pi.value = rawPrice.toFixed(2);
    // Remove old variant selector and warning
    var oldV = g('sfym-variant-wrap-' + id);
    if (oldV) oldV.remove();
    var oldW = g('sfym-warn-' + id);
    if (oldW) oldW.remove();
    // Show warning if no price
    if (rawPrice === 0) {
      var fieldEl = g('sfym-field-' + id);
      if (fieldEl) {
        var warn = document.createElement('div');
        warn.id = 'sfym-warn-' + id;
        warn.style.cssText = 'background:#fff3cd;border-left:3px solid #ffc107;padding:10px 12px;border-radius:0 4px 4px 0;font-size:11px;margin-top:4px;line-height:1.8;';
        var warnLink = 'https://wa.me/' + WSP + '?text=' + encodeURIComponent('Hola! Quiero cotizar: ' + title);
        warn.innerHTML =
          '<strong>&#9888; Precio no disponible.</strong><br>' +
          'Consulta el stock antes de continuar.<br>' +
          '<a href="' + warnLink + '" target="_blank" rel="noopener" ' +
          'style="display:inline-flex;align-items:center;gap:5px;margin-top:6px;background:#25D366;color:white;padding:6px 14px;border-radius:20px;text-decoration:none;font-weight:700;font-size:11px;">' +
          '&#x1F4AC; Pedir cotizacion personalizada</a>';
        fieldEl.appendChild(warn);
      }
    }
    // Fetch variants for this product
    if (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (shopProd) {
          var variants = shopProd.variants || [];
          var hasRealVariants = variants.length > 1 &&
            variants[0].option1 !== 'Estándar' &&
            variants[0].option1 !== 'Default Title';
          if (!hasRealVariants) return;
          var fieldEl = g('sfym-field-' + id);
          if (!fieldEl) return;
          var optionName = (shopProd.options && shopProd.options[0]) ? shopProd.options[0].name : 'Variante';
          var wrap = document.createElement('div');
          wrap.id = 'sfym-variant-wrap-' + id;
          wrap.style.cssText = 'margin-top:6px;';
          var selHtml = '<label style="display:block;font-size:11px;font-weight:600;color:#1c4b27;margin-bottom:3px;">' + esc(optionName) + '</label>';
          selHtml += '<select onchange="sfymCotVariantChange(' + id + ',this)" style="width:100%;padding:7px 10px;border:1px solid #c8dcc0;border-radius:5px;font-size:12px;color:#1c4b27;background:#fff;">';
          variants.forEach(function (v) {
            var vPrice = parseFloat(v.price) || 0;
            var priceLabel = vPrice > 0 ? ' — S/ ' + vPrice.toFixed(2) : ' — Consultar stock';
            selHtml += '<option value="' + v.id + '" data-price="' + vPrice + '">' + esc(v.option1) + priceLabel + '</option>';
          });
          selHtml += '</select>';
          wrap.innerHTML = selHtml;
          // Insert before warning or at end of field
          var warnEl = g('sfym-warn-' + id);
          if (warnEl) {
            fieldEl.insertBefore(wrap, warnEl);
          } else {
            fieldEl.appendChild(wrap);
          }
          // Auto-apply first variant price
          sfymCotVariantChange(id, wrap.querySelector('select'));
        })
        .catch(function () {});
    }
    up();
  }

  function variantChange(id, sel) {
    var opt = sel.options[sel.selectedIndex];
    var price = parseFloat(opt.getAttribute('data-price')) || 0;
    var p = prods.find(function (x) { return x.id === id; });
    if (p) p.price = price.toFixed(2);
    var pi = g('sfym-price-' + id);
    if (pi) pi.value = price.toFixed(2);
    var oldW = g('sfym-warn-' + id);
    if (oldW) oldW.remove();
    if (price === 0) {
      var fieldEl = g('sfym-field-' + id);
      if (fieldEl) {
        var title = (g('sfym-name-' + id) || {}).value || '';
        var warn = document.createElement('div');
        warn.id = 'sfym-warn-' + id;
        warn.style.cssText = 'background:#fff3cd;border-left:3px solid #ffc107;padding:10px 12px;border-radius:0 4px 4px 0;font-size:11px;margin-top:4px;line-height:1.8;';
        var warnLink = 'https://wa.me/' + WSP + '?text=' + encodeURIComponent('Hola! Quiero cotizar: ' + title);
        warn.innerHTML = '<strong>&#9888; Precio no disponible.</strong><br>Consulta el stock antes de continuar.<br>' +
          '<a href="' + warnLink + '" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:5px;margin-top:6px;background:#25D366;color:white;padding:6px 14px;border-radius:20px;text-decoration:none;font-weight:700;font-size:11px;">&#x1F4AC; Pedir cotizacion personalizada</a>';
        fieldEl.appendChild(warn);
      }
    }
    up();
  }

  /* -- RENDER PRODUCT EDITOR -- */
  function renderProdEditor() {
    var el = g('ccProdList');
    if (!el) return;
    if (!prods.length) {
      el.innerHTML = '<div style="text-align:center;padding:16px 8px;background:#f8faf6;border-radius:5px;border:1px dashed #92bc34;color:#6b7470;font-size:11px;line-height:1.6;">Agrega productos al carrito y pulsa <strong style="color:#1c4b27">Cargar desde mi carrito</strong></div>';
      return;
    }
    el.innerHTML = prods.map(function (p, i) {
      var pid = p.id;
      var dropStyle = 'display:none;position:absolute;top:100%;left:0;right:0;z-index:999;background:white;border:1px solid #c8dcc0;border-top:none;border-radius:0 0 6px 6px;box-shadow:0 6px 18px rgba(0,0,0,.12);max-height:240px;overflow-y:auto;';
      return (
        '<div class="sfym-cot-prod">' +
          '<div class="sfym-cot-prod-label">Producto ' + (i + 1) + '</div>' +
          '<button class="sfym-cot-prod-del" onclick="sfymCotDelProd(' + pid + ')" title="Eliminar">&times;</button>' +
          '<div id="sfym-field-' + pid + '" class="sfym-cot-field" style="margin-bottom:6px;position:relative;">' +
            '<label>Nombre</label>' +
            '<input id="sfym-name-' + pid + '" type="text" placeholder="Escribe para buscar..." value="' + esc(p.desc) + '"' +
            ' oninput="sfymCotUp();sfymCotSearch(' + pid + ',this.value);sfymCotProdF(' + pid + ',\'desc\',this.value)"' +
            ' onblur="setTimeout(function(){var d=document.getElementById(\'sfym-drop-' + pid + '\');if(d)d.style.display=\'none\';},200)">' +
            '<div id="sfym-drop-' + pid + '" style="' + dropStyle + '"></div>' +
          '</div>' +
          '<div class="sfym-cot-field" style="margin-bottom:6px">' +
            '<label>Detalle / Codigo (opcional)</label>' +
            '<input type="text" placeholder="Codigo, marca..." value="' + esc(p.detail) + '"' +
            ' oninput="sfymCotProdF(' + pid + ',\'detail\',this.value)">' +
          '</div>' +
          '<div class="sfym-cot-row2">' +
            '<div class="sfym-cot-field">' +
              '<label>Precio c/IGV (S/)</label>' +
              '<input id="sfym-price-' + pid + '" type="number" placeholder="0.00" value="' + esc(p.price) + '" step="0.01" min="0"' +
              ' oninput="sfymCotProdF(' + pid + ',\'price\',this.value)">' +
            '</div>' +
            '<div class="sfym-cot-field">' +
              '<label>Cantidad</label>' +
              '<input type="number" value="' + p.qty + '" min="1"' +
              ' oninput="sfymCotProdF(' + pid + ',\'qty\',this.value)">' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  /* -- UPDATE PREVIEW -- */
  function up() {
    setText('qCliente', g('ccCliente').value || '--');
    setText('qRuc',     g('ccRuc').value     || '--');
    setText('qCelular', g('ccCel').value     || '--');
    setText('qNum',     g('ccNum').value);
    setText('qFecha',   fmtDate(g('ccFecha').value));
    setText('qValidez', fmtDate(g('ccValidez').value));
    renderTable();
    renderFinancials();
    renderNotes();
  }

  function renderTable() {
    var rows = prods.filter(function (p) { return p.desc; });
    if (!rows.length) {
      g('qTbody').innerHTML = '<tr><td colspan="6" style="text-align:center;color:#aaa;padding:20px">Agrega productos en el panel izquierdo</td></tr>';
      return;
    }
    g('qTbody').innerHTML = rows.map(function (p) {
      var tot = parseFloat(p.price) || 0;
      var qty = parseInt(p.qty) || 1;
      var exIgv = tot / 1.18;
      var igvU = tot - exIgv;
      return (
        '<tr>' +
          '<td style="text-align:left">' +
            '<strong>' + esc(p.desc) + '</strong>' +
            (p.detail ? '<br><span style="font-size:9px;color:#666">' + esc(p.detail) + '</span>' : '') +
          '</td>' +
          '<td style="text-align:right">S/ ' + exIgv.toFixed(2) + '</td>' +
          '<td style="text-align:right">S/ ' + igvU.toFixed(2) + '</td>' +
          '<td style="text-align:center">' + qty + '</td>' +
          '<td style="text-align:right">S/ ' + (igvU * qty).toFixed(2) + '</td>' +
          '<td style="text-align:right">S/ ' + (tot * qty).toFixed(2) + '</td>' +
        '</tr>'
      );
    }).join('');
  }

  function renderFinancials() {
    var totalConIgv = 0;
    prods.filter(function (p) { return p.desc; }).forEach(function (p) {
      totalConIgv += (parseFloat(p.price) || 0) * (parseInt(p.qty) || 1);
    });
    var sub = totalConIgv / 1.18;
    var igv = totalConIgv - sub;
    var envMonto, envLabel, envTipo;
    var gratisCb = g('ccEnvioGratis');
    var montoEl  = g('ccEnvioMonto');
    if (gratisCb && gratisCb.checked) {
      envMonto = 0;  envLabel = 'GRATIS';  envTipo = 'gratis';
    } else {
      envMonto = montoEl ? (parseFloat(montoEl.value) || 0) : 0;
      envLabel = 'S/ ' + envMonto.toFixed(2);  envTipo = 'costo';
    }
    var dispEl = g('sfymEnvioDisplay');
    if (dispEl) {
      if (envTipo === 'gratis') {
        dispEl.textContent = '✓ Envío GRATIS';
        dispEl.style.cssText = 'margin-top:6px;padding:9px 12px;background:#d1fae5;border:1px solid #6ee7b7;border-radius:4px;font-size:12px;color:#065f46;font-weight:700;font-style:normal;';
      } else {
        dispEl.textContent = 'Envío con costo: ' + envLabel;
        dispEl.style.cssText = 'margin-top:6px;padding:9px 12px;background:#f8faf6;border:1px solid #d4dcd8;border-radius:4px;font-size:12px;color:#2d3d34;font-style:normal;';
      }
    }
    lastTotals = { sub: sub, igv: igv, envMonto: envMonto, envLabel: envLabel, total: totalConIgv + envMonto, envTipo: envTipo };
    setText('qSubtotal', fmtMoney(sub));
    setText('qIgv',      fmtMoney(igv));
    setText('qEnvio',    envLabel);
    setText('qTotal',    fmtMoney(totalConIgv + envMonto));
  }

  function renderNotes() {
    var items = [];
    document.querySelectorAll('.ccNoteCb').forEach(function (cb) {
      if (cb.checked) {
        var lbl = cb.closest ? cb.closest('label') : cb.parentElement;
        if (lbl) items.push(lbl.textContent.trim());
      }
    });
    var extra = g('ccNotaExtra').value;
    if (extra) items.push(extra);
    g('qNotesList').innerHTML = items.map(function (t) {
      return '<li>' + esc(t) + '</li>';
    }).join('');
  }

  /* -- SHIPPING -- */
  function onEnvio() { up(); }
  function envioToggle(which) {
    var gc = g('ccEnvioGratis'), cc = g('ccEnvioCosto'), m = g('ccEnvioMonto');
    if (!gc || !cc) { up(); return; }
    if (which === 'gratis') { cc.checked = !gc.checked; }
    else { gc.checked = !cc.checked; }
    if (m) m.disabled = gc.checked;
    up();
  }

  /* -- NUEVO -- */
  function nuevo() {
    if (!confirm('Crear nueva cotizacion? El numero se incrementara automaticamente.')) return;
    g('ccCliente').value = '';
    g('ccRuc').value = '';
    g('ccCel').value = '';
    g('ccNotaExtra').value = '';
    prods = [];
    var n = parseInt(localStorage.getItem('sfymCotN') || '0', 10) + 1;
    g('ccNum').value = 'COT-' + String(n).padStart(4, '0');
    localStorage.setItem('sfymCotN', n);
    var today = new Date();
    var exp = new Date(); exp.setDate(exp.getDate() + 7);
    g('ccFecha').value = isoDate(today);
    g('ccValidez').value = isoDate(exp);
    renderProdEditor();
    up();
  }

  /* -- PDF -- */
  function generarPDF() {
    up();
    var cotNum = g('ccNum').value;
    var quoteHTML = g('sfymQDoc').innerHTML;

    var CSS = [
      '* { margin:0; padding:0; box-sizing:border-box; }',
      'body { font-family:"Segoe UI",Arial,sans-serif; font-size:11px; color:#2d3d34; line-height:1.4; background:white; }',
      '.qc { background:white; padding:28px; max-width:800px; margin:auto; }',
      '.qh { background:linear-gradient(135deg,#1c4b27 0%,#0f3120 100%); color:white; padding:14px 22px; margin-bottom:18px; border-radius:4px; display:flex; justify-content:space-between; align-items:center; }',
      '.qh-brand { display:flex; align-items:center; gap:14px; }',
      '.qh-logo { height:52px; width:auto; background:white; padding:4px; border-radius:3px; }',
      '.qh-title h1 { font-size:17px; margin:0; font-weight:bold; }',
      '.qh-title p { font-size:10px; margin-top:2px; opacity:0.9; }',
      '.qbadge { background:#92bc34; color:#1c4b27; padding:7px 14px; display:inline-block; font-weight:bold; border-radius:3px; margin-bottom:18px; font-size:12px; text-transform:uppercase; }',
      '.qgrid { display:grid; grid-template-columns:1fr 1fr; gap:16px; margin-bottom:20px; }',
      '.qbox { background:#f8faf6; border-left:5px solid #92bc34; padding:13px; border-radius:2px; }',
      '.qbox h3 { color:#1c4b27; font-size:11px; font-weight:bold; text-transform:uppercase; margin-bottom:8px; border-bottom:1px solid #ddd; padding-bottom:4px; }',
      '.qbox p { margin:4px 0; font-size:10px; }',
      'table { width:100%; border-collapse:collapse; margin:12px 0; font-size:10px; }',
      'thead { background:#1c4b27; color:white; }',
      'th { padding:9px 8px; text-align:left; font-weight:bold; text-transform:uppercase; }',
      'td { padding:7px 8px; border-bottom:1px solid #d4dcd8; }',
      'tbody tr:nth-child(even) { background:rgba(146,188,52,0.08); }',
      '.qfin { background:#f8faf6; border-right:5px solid #92bc34; padding:13px; margin-top:18px; border-radius:2px; width:44%; margin-left:auto; }',
      '.qfin h3 { margin:0 0 8px; font-size:10px; color:#1c4b27; border-bottom:1px solid #ccc; padding-bottom:4px; }',
      '.qfrow { display:flex; justify-content:space-between; margin:4px 0; font-size:11px; }',
      '.qfrow.tot { background:white; border-top:2px solid #1c4b27; padding:9px 4px; margin-top:8px; font-weight:bold; color:#1c4b27; font-size:13px; }',
      '.qbank { margin-top:18px; font-size:10px; background:#f9f9f9; padding:10px 14px; border-left:4px solid #e9730f; display:flex; justify-content:space-between; align-items:center; gap:12px; }',
      '.qnotes { margin-top:18px; background:#fff3cd; border-left:4px solid #ffc107; padding:12px; font-size:10px; border-radius:2px; }',
      '.qnotes ul { margin-left:18px; margin-top:7px; line-height:1.7; }',
      '.qfooter { text-align:center; margin-top:36px; padding-top:10px; border-top:1px solid #eee; font-size:9px; color:#888; }',
      '.qfooter p { margin:2px 0; }',
      '@page { size:A4; margin:8mm; }'
    ].join('\n');

    var win = window.open('', '_blank', 'width=900,height=750');
    if (!win) { alert('Permite ventanas emergentes para generar el PDF.'); return; }
    win.document.write(
      '<!DOCTYPE html><html lang="es"><head>' +
      '<meta charset="UTF-8"><title>' + cotNum + '</title>' +
      '<style>' + CSS + '</style>' +
      '</head><body>' + quoteHTML +
      '<scr' + 'ipt>window.onload=function(){setTimeout(function(){window.print();},400);}<\/scr' + 'ipt>' +
      '</body></html>'
    );
    win.document.close();
  }

  /* -- ENVIAR SOLICITUD -- */
  function sfymEnviarSolicitud() {
    // a) Validar campos mínimos
    var cliente = g('ccCliente').value.trim();
    var emailEl = g('sfymClientEmail');
    var correo  = emailEl ? emailEl.value.trim() : '';
    if (!cliente) {
      alert('Por favor ingresa la Razón Social / Nombre del cliente.');
      return;
    }
    if (!correo) {
      alert('Por favor ingresa el correo electrónico del cliente.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo)) {
      alert('El correo electrónico no tiene un formato válido.');
      return;
    }
    if (!prods.length) {
      alert('Agrega al menos un producto antes de enviar.');
      return;
    }

    // b) Actualizar cálculos
    up();

    // c) Construir payload
    var envioTipoLabel = {
      gratis: 'Gratis',
      costo:  'Con costo',
      lima:   'Lima – Contraentrega',
      shalom: 'Shalom / Olva / Marvisur',
      custom: 'Personalizado'
    }[lastTotals.envTipo] || lastTotals.envTipo;

    var notasArr = [];
    document.querySelectorAll('.ccNoteCb').forEach(function (cb) {
      if (cb.checked) {
        var lbl = cb.closest ? cb.closest('label') : cb.parentElement;
        if (lbl) notasArr.push(lbl.textContent.trim());
      }
    });
    var extra = g('ccNotaExtra').value.trim();
    if (extra) notasArr.push(extra);

    var payload = {
      cot_numero:        g('ccNum').value,
      cot_fecha_emision: fmtDate(g('ccFecha').value),
      cot_valido_hasta:  fmtDate(g('ccValidez').value),
      cliente_nombre:    cliente,
      cliente_ruc:       g('ccRuc').value.trim(),
      cliente_celular:   g('ccCel').value.trim(),
      cliente_correo:    correo,
      productos: prods.filter(function (p) { return p.desc; }).map(function (p) {
        var precio = parseFloat(p.price) || 0;
        var qty    = parseInt(p.qty)     || 1;
        return {
          nombre:         p.desc,
          codigo:         p.detail || '',
          precio_con_igv: parseFloat(precio.toFixed(2)),
          cantidad:       qty,
          subtotal:       parseFloat((precio * qty).toFixed(2))
        };
      }),
      fin_subtotal: parseFloat(lastTotals.sub.toFixed(2)),
      fin_igv:      parseFloat(lastTotals.igv.toFixed(2)),
      fin_envio:    parseFloat(lastTotals.envMonto.toFixed(2)),
      fin_total:    parseFloat(lastTotals.total.toFixed(2)),
      envio_tipo:   envioTipoLabel,
      notas:        notasArr
    };

    // d) Deshabilitar botón
    var btn = g('sfymBtnEnviar');
    if (btn) { btn.disabled = true; btn.textContent = 'Enviando...'; }

    var WEBHOOK_URL = 'https://n8n.solucionesfym.com/webhook/cotizacion-fym';

    // e) Enviar
    fetch(WEBHOOK_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    })
    .then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      return r.json();
    })
    .then(function () {
      // f) Éxito
      if (btn) { btn.disabled = false; btn.innerHTML = '&#x1F4E7; Enviar Solicitud'; }
      var msg = g('sfymMsgEnvio');
      if (msg) {
        msg.style.cssText = 'display:block;margin:8px 18px 0;padding:10px 14px;border-radius:6px;font-size:12px;font-weight:600;background:#d1fae5;color:#065f46;border-left:3px solid #10b981;';
        msg.textContent = '✅ Solicitud enviada correctamente. Nos contactaremos contigo a la brevedad.';
        setTimeout(function () { msg.style.display = 'none'; }, 8000);
      }
    })
    .catch(function () {
      // g) Error
      if (btn) { btn.disabled = false; btn.innerHTML = '&#x1F4E7; Enviar Solicitud'; }
      var msg = g('sfymMsgEnvio');
      if (msg) {
        msg.style.cssText = 'display:block;margin:8px 18px 0;padding:10px 14px;border-radius:6px;font-size:12px;font-weight:600;background:#fee2e2;color:#991b1b;border-left:3px solid #ef4444;';
        msg.textContent = '❌ Error al enviar. Por favor intenta de nuevo o contáctanos directamente.';
      }
    });
  }

  /* -- EXPORTS -- */
  window.sfymCotUp          = up;
  window.sfymCotAddProd     = addProd;
  window.sfymCotDelProd     = removeProd;
  window.sfymCotProdF       = updProd;
  window.sfymCotEnvio       = onEnvio;
  window.sfymCotEnvioToggle = envioToggle;
  window.sfymCotPDF         = generarPDF;
  window.sfymCotNuevo       = nuevo;
  window.sfymCotFromCart    = fromCart;
  window.sfymCotFechaChange = fechaChange;
  window.sfymCotSearch        = searchProd;
  window.sfymCotSelectProd    = selectProd;
  window.sfymCotVariantChange = variantChange;
  window.sfymEnviarSolicitud  = sfymEnviarSolicitud;

  /* -- START -- */
  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('ccNoteCb')) up();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
